<template>

	<!-- Your Transactions Card 2 -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }">
		<template #title>
			<h6 class="font-semibold m-0">{{ title }}</h6>
		</template>
		<p slot="extra" class="card-header-date">
			<a-icon type="calendar" theme="filled" />
			<span>{{ date }}</span>
		</p>
		<a-list
			class="transactions-list"
			item-layout="horizontal"
			:split="false"
			:data-source="data"
		>
			<a-list-item slot="renderItem" slot-scope="item">
				<template v-if="item.period">
					<h6>{{ item.period }}</h6>
				</template>
				<template v-else>
					<a-list-item-meta
						:title="item.title"
						:description="item.datetime"
					>
						<a-avatar :size="34" v-if="item.type == 1" slot="avatar" style="background-color: #5A5A5A">
							<a-icon type="check" />
						</a-avatar>
						<a-avatar :size="34" v-if="item.type == 2" slot="avatar" style="background-color: #5A5A5A">
							<a-icon type="login" />
						</a-avatar>
					</a-list-item-meta>
					<div class="amount">
						<span v-if="item.type == 1" class="text-success">
							{{ item.amount }}
						</span>
						<span v-if="item.type == 2" class="text-warning">
							{{ item.amount }}
						</span>
					</div>
				</template>
			</a-list-item>
		</a-list>
	</a-card>
	<!-- / Your Transactions Card 2 -->

</template>

<script>

	export default ({
		props: {
			title: {
				type: String,
				default: "Transactions",
			},
			date: {
				type: String,
				default: String(new Date()),
			},
			data: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
			}
		},
	})

</script>